import { useCustomerContext } from 'pages/Customer/CustomerContext';
import { Mixpanel } from 'services/mixpanel';
import Banner from 'shared/components/Banner';
import { usePermissions } from 'shared/hooks/usePermissions';
import { useFinancialContext } from '../../Financial/FinancialContext';

const NoContractBanner = () => {
  const { customer } = useCustomerContext();
  const { e } = usePermissions();

  const { openCreateContractModal, openResellerContractModal } =
    useFinancialContext();

  const isReseller = e('reseller-create');

  const action = () => {
    Mixpanel.track('customers-principal-opened-contract-modal');
    if (isReseller) {
      openResellerContractModal();
    } else {
      openCreateContractModal();
    }
  };

  return !customer.isRecordIncomplete &&
    (!customer.contract || !customer.contract.id) ? (
    <Banner
      colorScheme="red"
      content="Cliente sem contrato"
      subContent="Esse cliente ainda está sem um contrato"
      action={action}
    />
  ) : (
    <></>
  );
};

export default NoContractBanner;
